import { ReactComponent as Frontend } from '../../images/services/frontend.svg';
import { ReactComponent as Backend } from '../../images/services/backend.svg';

export const services = [
  {
    id: 0,
    Svg: Frontend,
    title: 'Front End Development',
    description:
      'Provide Responsive Single Page and Multi Page applications using React and JavaScript.',
  },
  {
    id: 1,
    Svg: Backend,
    title: 'Back End Development',
    description:
      'Provide backend applications, relational databases and APIs using Ruby on Rails framework.',
  },
];

export default 'Services Data';
